import { FILE_UPLOAD_URL_CALL, FILE_UPLOAD_CALL } from '@instructure/quiz-common';
var path = 'calls';
export function fileUploading(state) {
  return state.getIn([path, FILE_UPLOAD_URL_CALL, 'requestStatus']) === 'calling' || state.getIn([path, FILE_UPLOAD_CALL, 'requestStatus']) === 'calling';
}